<template>
  <div class="container-fluid pb-12">
    <div class="row">
      <div class="search-block search-block--articles w-100">
        <div class="container container--article">
          <div class="row justify-center">
            <h2 class="fz24 fz-md-42 fw-bold mb-6 white-color col-xxl-7 col-9 text-center">Добро пожаловать в читальный зал!</h2>
            <p
              class="fz-md-18 fz-14 white-color mb-11 col-xxl-6 col-md-8 col-12 text-center"
            >Читайте сотни публикаций, следите за свежими новостями из мира строительства, добавляйте статьи своей компании.
            </p>
            <div class="search-input_block search-input_block--articles d-flex posr col-xxl-7 col-md-9 col-12">
              <input
                class="search-global form-control standart-input input"
                type="text"
                v-model="searchArticle"
                placeholder="Поиск по статьям"
                @keyup.enter="getArticle"
              />
              <button aria-label="Начать поиск" @click="getArticle">
                <div class="search_btn">
                  <i class="icon-arrow-right active-color fz20"></i>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- лоадер -->
      <preloader v-if="loading"></preloader>

      <div class="content container container--article pt-12 pt-md-11 col-xxl-8 col-md-10 col-12">
        <!-- Все новости -->
        <div class="row justify-center mb-11" v-if="!loading">
          <div v-if="articles.length > 0">
            <!-- all-post -->
            <div class="mb-10 posr posts">
              <article
                class="post"
                v-for="(post, idx) in articles"
                :key="post.id"
                itemscope
                itemtype="http://schema.org/Article"
              >
                <a
                  :href="'/articles/' + post.lang_versions[1].url_certain_lang"
                  class="post_wrapper d-flex flex-column"
                  :class="{ 'post_wrapper-small' : ![3, 6, 15].includes(idx + 1) }"
                  itemprop="url"
                >
                  <div class="post_img">
                    <img
                      ref="cardImage"
                      width="100%"
                      class="mw-100 mx-auto d-block"
                      :src="getImgUrl(post)"
                      onerror="this.src='/dist/assets/front_white/img/svg/no-pic.svg'"
                      :alt="post.lang_versions[1].title"
                      itemprop="image"
                    />
                    <span class="post_img-views d-flex align-center fz13"><i class="icon-views-eye fz12"></i> {{ post.lang_versions[1].quant_user_views || post.quant_user_views }}</span>
                  </div>
                  <p
                    itemprop="headline"
                    class="fw-bold post_title"
                    :class="{'h3New': idx === 0, 'fz18': idx >= 1}"
                  >{{post.lang_versions[1].title}}
                  </p>
                </a>
              </article>
            </div>
          </div>
          <div
            v-else
            class="col-xxl-10 col-12 d-flex flex-column align-center mx-auto py-md-12 not-found pt-0"
          >
            <p class="notfound-title mb-md-9 mb-6">{{$t('Подходящих публикаций не найдено')}}</p>
            <bim-button
              width="200"
              color="gray"
              @click="() => {
                this.searchArticle = ''
                this.getArticle()
              }"
              label="Очистить поиск"
              size="l"
            />
          </div>
        </div>

        <div class="w-100"></div>
        <bim-pagination
          :active-page="page"
          :total-pages="totalPages"
          @changePage="onChangePage"
          scroll-to=".content"
        />
      </div>

      <AdfoxLongWide class="my-9 mx-auto w-100" />
    </div>
  </div>
</template>

<script>
import search from './SearchArticles.vue'
import bimPagination from '@bimlib/components/bimPagination'

import AdfoxLongWide from '@/components/banners/adfox-long-wide'

const urlParams = new URLSearchParams(window.location.search)

export default {
  components: {
    search,
    bimPagination,
    AdfoxLongWide
  },
  data () {
    return {
      articles: [],
      page: 1,
      itemsOnPage: 15,
      totalItems: 0,
      searchArticle: '',
      category: 'all',
      params: 'readingroom',
    }
  },
  created () {
    this.searchArticle = urlParams.get('search') || ''
    this.page = +urlParams.get('page') || 1

    this.getArticle()
  },
  watch: {
    searchArticle (val) {
      if (this.page !== 1) {
        this.onChangePage(1)
      }

      if (val) {
        urlParams.set('search', val)
      } else {
        urlParams.delete('search')
      }

      window.history.replaceState({}, '', `${location.pathname}?${urlParams}`)
    },
  },
  computed: {
    loading () {
      return this.$store.getters.getLoading
    },
    totalPages () {
      return Math.ceil(this.totalItems / this.itemsOnPage)
    },
  },
  methods: {
    getImgUrl(post, index) {
      const { index_img, head_img } = post.lang_versions[1]

      const convert = path => `/uploads${path}` // ?size=${width}x${height}`

      let img = '/dist/assets/front_white/img/svg/no-pic.svg'
      if (index_img) {
        img = convert(index_img)
      }
      else if (head_img) {
        img = convert(head_img)
      }

      return img
    },
    onChangePage(page) {
      this.page = page

      // добавим query параметр в url
      const url = new URL(window.location.href)

      url.searchParams.set('page', page)

      this.getArticle()

      window.history.replaceState({}, '', url.toString())
    },
    async fetchArticles (context) {
      return this.$store.dispatch('searchArticles', context)
    },
    async getArticle () {
      this.$store.dispatch('loader', true)

      try {
        const articles = await this.fetchArticles({
          limit: this.itemsOnPage,
          offset: (this.page - 1) * this.itemsOnPage,
          name: this.searchArticle
        })

        this.articles = articles.posts
        this.totalItems = articles.count
      } catch (e) {
        this.articles = []
        this.totalItems = 0
      }

      this.$store.dispatch('loader', false)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.container--article {
  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
    max-width : 100%;
  }

  &.content {
    max-width: 922px;
  }
}

.show-more_btn {
  width            : 10.4rem;
  height           : 2.9333rem;
  background-color : $active-superlight;
}

.top_menu {
  height : 46px;

  .menu-item {
    color : $text-second-light;

    &:hover {
      color : $text-main;
    }

    &.active {
      color : $active;
    }
  }
}

.search-block {
  padding         : 5.8667rem 0 5.2rem;
  background      : url("/dist/assets/front_white/img/articles/banner.png") no-repeat 50%;
  background-size : cover;
}

.search-block--articles {
  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
    padding-top    : 5.8667rem;
    padding-bottom : 0;
  }
}

.search-input_block--articles {
  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
    transform : translateY(50%);
  }
}

.icon-input-droplist {
  margin-left   : 0.4867rem;
  padding-right : 0.2rem;

  font-size     : 0.48rem;

  transform     : rotate(-90deg);
}

.article-tags {
  .tag {
    margin : 0 0.5333rem 0.6667rem 0;
  }
}

// .post_wrapper - все стили к этому классу прописаны в файле src\front_white\sass\components\_athoms.scss со строки 698


// Новые
.post-new_wrapper {
  height     : 20rem;
  max-height : 20rem;

  .post_img {
    max-width  : 100%;
    min-height : 11.1333rem;
    max-height : 11.1333rem;
    overflow   : hidden;

    img {
      min-height      : 100%;

      object-fit      : cover;
      object-position : 50%;
    }
  }

  .post_title {
    overflow      : hidden;

    line-height   : 1.4;
    text-overflow : ellipsis;
  }
}

// Новости портала
.post-newsPortal_wrapper {
  height        : 17.4rem;
  overflow      : hidden;

  border-radius : 0.3333rem;

  .post_img {
    position : relative;

    height   : 100%;

    &:after {
      content          : "";
      position         : absolute;
      top              : 0;
      left             : 0;

      width            : 100%;
      height           : 100%;

      background-image : linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0),
          rgba(0, 0, 0, 0.68)
      );
    }

    img {
      min-width       : 100%;
      min-height      : 100%;

      object-fit      : cover;
      object-position : 50%;
    }
  }

  .post_title {
    bottom        : 3.1333rem;
    left          : 2.6rem;

    width         : calc(100% - 78px);
    height        : 4.8rem;
    overflow      : hidden;

    line-height   : 1.4;
    text-overflow : ellipsis;
  }

  .post_date {
    bottom : 1.1333rem;
    left   : 2.6rem;
  }
}

// Популярные
.post-popular_wrapper {
  height     : 21.9333rem;
  max-height : 21.9333rem;

  .post_img {
    min-height : 11.88rem;

    img {
      height : 100%;
    }
  }

  .post_title {
    height      : 6.4rem;

    line-height : 1.4;
  }

  &_small {
    height     : 246px;
    max-height : 246px;

    .post_img {
      min-height : 129px;
    }

    .post_title {
      height : 4.8rem;
    }
  }
}

.search_btn {
  right : 1.2667rem;
}

.mb-28 {
  margin-bottom : 1.8667rem;
}

.not_found{
  h1 {
    font-size: 2em;
    font-weight: bold;
  }
}
.notfound-title {
  font-size   : 32px;
  font-weight : bold;
  text-align: center;
}

.notfound-subtitle {
  font-size : 18px;
}

</style>
